
const Hotels = () => {
  const hotels = [
    {
      name: "",
      img: "",
      location: "",
      address: "",
      link: "",
      phone: "",
      price: "",
      stars: ""
    },
    {
      name: "",
      img: "",
      location: "",
      address: "",
      link: "",
      phone: "",
      price: "",
      stars: ""
    },
    {
      name: "",
      img: "",
      location: "",
      address: "",
      link: "",
      phone: "",
      price: "",
      stars: ""
    },
  ];

  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-great-vibes text-4xl text-center text-rose-600 mb-12">Alojamiento</h2>

        <div className="relative text-center">
          {/* <div className="absolute left-1/2 h-full w-0.5 bg-rose-200 transform -translate-x-1/2"></div> */}
          <p class="text-gray-700 mb-6 text-center inline-block">Estamos buscando acuerdos con varios hoteles en Valencia.<br></br> <br></br>¡Iremos poniendo aquí la información en cuanto los consigamos!</p>

          <div className="grid">
            <div className="space-y-8 justify-center">
                {hotels.map((hotel, index) => (
                  <div key={index} className={`bg-rose-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow justify-center ${index == 1 ? 'opacity-70' : ''} ${index == 2 ? 'opacity-50' : ''}`} style={{ minHeight: '100px', minWidth: '350px' }}>
                    <h3 className="text-xl font-semibold text-rose-600 mb-4">{hotel.name}</h3>                  
                    <div className="space-y-3">
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hotels;
